'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'dumpster-fire';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'f794';
var svgPathData = 'M77.6 80l97.3 0-21.8 160-90.1 0 0 0-12 0 26.7-160zM581.2 192.5c6.8 5.9 13.2 11.8 19.2 17.8l-24.4-146.3-512 0-29.3 176-2.7 16 33 0 28.9 224 16.1 0-4.1-32 176.2 0c-1.7-5.2-3.2-10.6-4.5-16l-173.8 0-22.7-176 233.5 0c4.4-6.5 8.9-12.7 13.4-18.5l0-157.5 120.7 0 7.2 51.8 18.7 18.7-9.8-70.6 97.6 0 18.7 112.5zM191 80l121 0 0 160-142.8 0 21.8-160zM500.7 244.8L448 192.2c-42.7 26.7-128 102.4-128 192 0 88.4 71.6 160 160 160s160-71.6 160-160c0-26.7-19.2-96-96-160-15.4 15.4-26 26-32 32l-11.3-11.3zm44.1 1.2c64.3 58.4 79.2 117.9 79.2 138.1 0 49.8-25.3 93.7-63.7 119.6 9.9-14.1 15.7-31 15.7-49.2 0-70.4-96-134.4-96-134.4s-96 64-96 134.4c0 18.2 5.8 35.1 15.7 49.2-38.4-25.9-63.7-69.8-63.7-119.6 0-39.7 19-77.6 44.5-109.6 21.3-26.7 46.2-48.2 65.4-61.8l54.7 54.7 11.3 11.3c5.9-5.9 16.8-16.8 32.8-32.8zM560 454.6c0 39.6-34.8 73.6-80 73.6s-80-34-80-73.6c0-28.5 20-58.2 43.5-82.5 13.8-14.3 27.8-25.6 36.5-32.2 8.8 6.6 22.7 17.9 36.5 32.2 23.5 24.3 43.5 53.9 43.5 82.5z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faDumpsterFire = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;